(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["8ight-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.eight-landing').forEach((landing) => {
    const navLinks = landing.querySelectorAll('[data-eight-nav-link]');
    const about = landing.querySelector('#eight-about');
    const aboutClose = landing.querySelector('[data-eight-about-close]');
    const privacy = landing.querySelector('#eight-privacy');
    const privacyClose = landing.querySelector('[data-eight-privacy-close]');
    const privacyLinks = landing.querySelectorAll('[data-eight-privacy-link]');
    const splash = landing.querySelector('[data-eight-splash]');
    const slides = landing.querySelectorAll('[data-eight-slide]');
    const slideInterval = Number(landing.dataset.eightSlideInterval) || 5000;
    const splashDuration = Number(landing.dataset.eightSplashDuration) || 2000;
    const hashByTarget = {
      home: '#eight-home',
      about: '#eight-about',
      privacy: '#eight-privacy',
    };

    const setActiveNav = function (target) {
      navLinks.forEach((link) => {
        const isActive = link.dataset.eightNavTarget === target;
        link.classList.toggle('active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }

        if (link.dataset.eightNavTarget === 'about') {
          link.setAttribute('aria-expanded', String(isActive));
        } else {
          link.setAttribute('aria-expanded', 'false');
        }
      });
    };

    const closePanels = function () {
      landing.classList.remove('eight-landing--about-open');
      landing.classList.remove('eight-landing--privacy-open');

      if (about) {
        about.setAttribute('aria-hidden', 'true');
      }

      if (privacy) {
        privacy.setAttribute('aria-hidden', 'true');
      }
    };

    const renderTarget = function (target) {
      closePanels();

      if (target === 'about') {
        landing.classList.add('eight-landing--about-open');

        if (about) {
          about.setAttribute('aria-hidden', 'false');
        }

        setActiveNav('about');
        return;
      }

      if (target === 'privacy') {
        landing.classList.add('eight-landing--privacy-open');

        if (privacy) {
          privacy.setAttribute('aria-hidden', 'false');
        }

        setActiveNav('home');
        return;
      }

      setActiveNav('home');
    };

    const getTargetFromHash = function () {
      if (window.location.hash === hashByTarget.about) {
        return 'about';
      }

      if (window.location.hash === hashByTarget.privacy) {
        return 'privacy';
      }

      return 'home';
    };

    const updateHash = function (target) {
      const nextHash = hashByTarget[target] || hashByTarget.home;

      if (window.location.hash === nextHash) {
        return;
      }

      window.history.pushState(null, '', `${window.location.pathname}${window.location.search}${nextHash}`);
    };

    const clearHash = function () {
      if (window.location.hash === '') {
        return;
      }

      window.history.pushState(null, '', `${window.location.pathname}${window.location.search}`);
    };

    const navigateTo = function (target) {
      renderTarget(target);
      updateHash(target);
    };

    const openAbout = function () {
      navigateTo('about');
    };

    const openPrivacy = function () {
      navigateTo('privacy');
    };

    const closeToHome = function () {
      navigateTo('home');
    };

    navLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();

        if (link.dataset.eightNavTarget === 'about') {
          openAbout();
        } else if (link.hasAttribute('data-eight-clear-hash')) {
          renderTarget('home');
          clearHash();
        } else {
          closeToHome();
        }
      });
    });

    if (aboutClose) {
      aboutClose.addEventListener('click', closeToHome);
    }

    if (privacyClose) {
      privacyClose.addEventListener('click', closeToHome);
    }

    privacyLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openPrivacy();
      });
    });

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeToHome();
      }
    });

    const syncPanelFromHash = function () {
      renderTarget(getTargetFromHash());
    };

    syncPanelFromHash();
    window.addEventListener('hashchange', syncPanelFromHash);
    window.addEventListener('popstate', syncPanelFromHash);

    if (splash) {
      const hasSuccessfulSignup = Boolean(landing.querySelector('.eight-landing__success'));

      if (hasSuccessfulSignup) {
        splash.hidden = true;
        splash.setAttribute('aria-hidden', 'true');
      } else {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const splashDelay = prefersReducedMotion ? 200 : splashDuration;
        const splashExitDelay = prefersReducedMotion ? 0 : 850;

        window.setTimeout(() => {
          splash.classList.add('eight-landing__splash--out');
          splash.setAttribute('aria-hidden', 'true');

          window.setTimeout(() => {
            splash.hidden = true;
          }, splashExitDelay);
        }, splashDelay);
      }
    }

    if (slides.length > 1) {
      landing.classList.add('eight-landing--slideshow-ready');

      let activeSlideIndex = Array.from(slides).findIndex((slide) => slide.classList.contains('active'));

      if (activeSlideIndex < 0) {
        activeSlideIndex = 0;
        slides[activeSlideIndex].classList.add('active');
      }

      window.setInterval(() => {
        slides[activeSlideIndex].classList.remove('active');
        activeSlideIndex = (activeSlideIndex + 1) % slides.length;
        slides[activeSlideIndex].classList.add('active');
      }, slideInterval);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
